import { Faq } from "../../../../models/Faq";

export function setUpFAQLP(data = []) {
  let answersData = Faq.fromApiArray(data)
  if (answersData.length) {
    let html = '';
    for (let i = 0; i < answersData.length; i++) {
      const item = answersData[i];
      html += item.genBox(i + 1);
    }
    $('.section-answer-question .section-data .scroll-box').html(html);
  }

  $("body").on("click", ".section-answer-question .section-data .faq-item .border-box .title-box", function () {
    $(this).parent().parent().toggleClass("active");
  })
}